var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { LEAKAGE_CAUSE_WORKER_WORKS_BEFORE_OPTIONS } from '@shared/constants/waterDamageConstants';
import { INSURER_CONFIG } from '@shared/insurer';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
let LeakageCauseWorkerWorksBeforeQuestion = class LeakageCauseWorkerWorksBeforeQuestion extends QuestionComponent {
    updateClaim(leakageCauseWorkerWorksBefore) {
        this.updateAndSaveWaterDamageQualification({
            qualificationPayload: {
                leakageCauseWorkerWorksBefore,
            },
            step: this.step,
        });
    }
    get leakageCauseWorkerWorksBeforeOptions() {
        return Object.values(LEAKAGE_CAUSE_WORKER_WORKS_BEFORE_OPTIONS);
    }
    get panelTitle() {
        return this.$tc('claim.qualification.leakage_cause_worker_works_before.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.leakage_cause_worker_works_before.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        if (!this.waterDamageQualification.leakageCauseWorkerWorksBefore) {
            return null;
        }
        const option = LEAKAGE_CAUSE_WORKER_WORKS_BEFORE_OPTIONS[this.waterDamageQualification.leakageCauseWorkerWorksBefore];
        return option ? this.$tc(option.answerTradKey, 0) : null;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b;
        if (this.hideHelpLink &&
            ((_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.leakageCauseWorkerWorksBefore) === null || _b === void 0 ? void 0 : _b.showHelpLink) === false) {
            return false;
        }
        return true;
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], LeakageCauseWorkerWorksBeforeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], LeakageCauseWorkerWorksBeforeQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], LeakageCauseWorkerWorksBeforeQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
LeakageCauseWorkerWorksBeforeQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], LeakageCauseWorkerWorksBeforeQuestion);
export default LeakageCauseWorkerWorksBeforeQuestion;
